import React from 'react';
import PropTypes from 'prop-types';
import RenderCheckBoxInputField from 'components/form/InputFields/RenderCheckBoxInputField';
import RenderTextInputField from 'components/form/InputFields/RenderTextInputField';
import SubmitButton from 'components/button/SubmitButton';
import translate from 'components/hoc/translate';
import authHelper from 'helpers/auth';
import validations from 'helpers/forms/validations';
import { ButtonWrapper, FormWrapper, Item, Row, Section } from 'components/ui/table/elements';
import { connect } from 'react-redux';
import { reduxForm, Field, isInvalid } from 'redux-form';
import compose from 'recompose/compose';

class WebhooksCreate extends React.Component {
    componentDidMount() {
        const {
            initialize,
        } = this.props;

        initialize({
            'is_active': true,
        });
    }

    render() {
        const {
            handleSubmit,
            handleSubmitForm,
            invalid,
            pristine,
            submitting,
            translate,
        } = this.props;

        const isProvider = authHelper.isProvider();
        const isReseller = authHelper.isReseller();

        return (
            <FormWrapper>
                <form onSubmit={ handleSubmit(handleSubmitForm) }>
                    <Section title={ translate('resources.webhooks.forms.general') }>
                        <Row>
                            <Item>
                                <Field
                                    component={ RenderTextInputField }
                                    fullWidth={ true }
                                    label={ translate('resources.webhooks.fields.name') }
                                    name='name'
                                    type='text'
                                    validate={ validations.required }
                                />
                            </Item>
                        </Row>

                        <Row>
                            <Item>
                                <Field
                                    component={ RenderTextInputField }
                                    fullWidth={ true }
                                    label={ translate('resources.webhooks.fields.url') }
                                    name='url'
                                    type='text'
                                    validate={ [
                                        validations.required,
                                        validations.url,
                                    ] }
                                />
                            </Item>
                        </Row>

                        <Row>
                            <Item>
                                <Field
                                    component={ RenderCheckBoxInputField }
                                    fullWidth={ true }
                                    label={ translate('resources.webhooks.fields.is_active') }
                                    name='is_active'
                                    type='text'
                                />
                            </Item>
                        </Row>
                    </Section>

                    { isReseller &&
                        <Section title={ translate('resources.webhooks.forms.actions') }>
                            <Row>
                                <Item>
                                    <Field
                                        component={ RenderCheckBoxInputField }
                                        fullWidth={ true }
                                        label={ translate('resources.webhooks.fields.action_booking_created') }
                                        name='action_booking_created'
                                        type='text'
                                    />
                                </Item>
                            </Row>

                            <Row>
                                <Item>
                                    <Field
                                        component={ RenderCheckBoxInputField }
                                        fullWidth={ true }
                                        label={ translate('resources.webhooks.fields.action_booking_modified') }
                                        name='action_booking_modified'
                                        type='text'
                                    />
                                </Item>
                            </Row>

                            <Row>
                                <Item>
                                    <Field
                                        component={ RenderCheckBoxInputField }
                                        fullWidth={ true }
                                        label={ translate('resources.webhooks.fields.action_booking_cancelled') }
                                        name='action_booking_cancelled'
                                        type='text'
                                    />
                                </Item>
                            </Row>
                            <Row>
                                <Item>
                                    <Field
                                        component={ RenderCheckBoxInputField }
                                        fullWidth={ true }
                                        label={ translate('resources.webhooks.fields.action_booking_initialised') }
                                        name='action_booking_initialised'
                                        type='text'
                                    />
                                </Item>
                            </Row>
                            <Row>
                                <Item>
                                    <Field
                                        component={ RenderCheckBoxInputField }
                                        fullWidth={ true }
                                        label={ translate('resources.webhooks.fields.action_booking_under_review') }
                                        name='action_booking_under_review'
                                        type='text'
                                    />
                                </Item>
                            </Row>
                        </Section>
                    }

                    { isProvider &&
                        <Section title={ translate('resources.webhooks.forms.actions') }>
                            <Row>
                                <Item>
                                    <Field
                                        component={ RenderCheckBoxInputField }
                                        fullWidth={ true }
                                        label={ translate('resources.webhooks.fields.action_reservation_created') }
                                        name='action_reservation_created'
                                        type='text'
                                    />
                                </Item>
                            </Row>

                            <Row>
                                <Item>
                                    <Field
                                        component={ RenderCheckBoxInputField }
                                        fullWidth={ true }
                                        label={ translate('resources.webhooks.fields.action_reservation_modified') }
                                        name='action_reservation_modified'
                                        type='text'
                                    />
                                </Item>
                            </Row>

                            <Row>
                                <Item>
                                    <Field
                                        component={ RenderCheckBoxInputField }
                                        fullWidth={ true }
                                        label={ translate('resources.webhooks.fields.action_reservation_cancelled') }
                                        name='action_reservation_cancelled'
                                        type='text'
                                    />
                                </Item>
                            </Row>
                        </Section>
                    }

                    <Section>
                        <Row>
                            <ButtonWrapper>
                                <SubmitButton
                                    disabled={ pristine || submitting || invalid }
                                    loading={ submitting }
                                />
                            </ButtonWrapper>
                        </Row>
                    </Section>
                </form>
            </FormWrapper>
        );
    }
}

WebhooksCreate.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    handleSubmitForm: PropTypes.func.isRequired,
    initialize: PropTypes.func,
    invalid: PropTypes.bool,
    pristine: PropTypes.bool,
    submitting: PropTypes.bool,
    translate: PropTypes.func.isRequired,
};

const mapStateToProps = (state, props) => {
    const {
        form,
    } = props;

    return {
        invalid: isInvalid(form)(state),
    };
};

const enhance = compose(
    translate,
    connect(
        mapStateToProps,
        null,
    ),
    reduxForm(),
);

export default enhance(WebhooksCreate);



// WEBPACK FOOTER //
// ./src/pages/webhooks/create/WebhooksCreate.js